var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdminPage',[_c('template',{slot:"header"},[_vm._v("Dashboard")]),_c('h3',[_vm._v("Hallo "+_vm._s(_vm.localClient.firstName)+" "+_vm._s(_vm.localClient.lastName)+"!")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }